
import ShieldCheck from '@/assets/icons/fontawesome/duotone/shield-check.svg?inline'

export default {
  components: {
    ShieldCheck,
  },
}
